import { render, staticRenderFns } from "./LoginWallModal.vue?vue&type=template&id=963627f2&"
import script from "./LoginWallModal.vue?vue&type=script&lang=js&"
export * from "./LoginWallModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports